import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent
      ),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then(
            (r) => r.DASHBOARD_ROUTES
          ),
      },
      {
        path: 'clinics',
        loadChildren: () =>
          import('./features/clinics/clinics.routes').then(
            (r) => r.CLINICS_ROUTES
          ),
      },
      {
        path: 'doctors',
        loadChildren: () =>
          import('./features/doctors/doctors.routes').then(
            (r) => r.DOCTORS_ROUTES
          ),
      },
      {
        path: 'patients',
        loadChildren: () =>
          import('./features/patients/patients.routes').then(
            (r) => r.PATIENTS_ROUTES
          ),
      },
      {
        path: 'appointments',
        loadChildren: () =>
          import('./features/appointments/appointments.routes').then(
            (r) => r.APPOINTMENTS_ROUTES
          ),
      },
      {
        path: 'availability',
        loadChildren: () =>
          import('./features/availability/availability.routes').then(
            (r) => r.AVAILABILITY_ROUTES
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then(
            (r) => r.SETTINGS_ROUTES
          ),
      },
    ],
  },
  {
    path: 'calendar-oauth/complete',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './features/calendar-integration/pages/calendar-oauth-complete/calendar-oauth-complete.component'
      ).then((m) => m.CalendarOAuthCompleteComponent),
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./layouts/auth-layout/auth-layout.component').then(
        (m) => m.AuthLayoutComponent
      ),
    canActivate: [noAuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/auth/auth.routes').then((r) => r.AUTH_ROUTES),
      },
    ],
  },
  {
    path: 'book',
    loadComponent: () =>
      import('./layouts/public-layout/public-layout.component').then(
        (m) => m.PublicLayoutComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/public-booking/pages/book-start/book-start.component').then(
            (m) => m.PublicBookStartComponent
          ),
      },
      {
        path: 'schedule',
        loadComponent: () =>
          import('./features/public-booking/pages/book-schedule/book-schedule.component').then(
            (m) => m.PublicBookScheduleComponent
          ),
      },
    ],
  },
  {
    path: 'appointments/rsvp',
    loadComponent: () =>
      import('./layouts/public-layout/public-layout.component').then(
        (m) => m.PublicLayoutComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/public-booking/pages/rsvp/rsvp.component').then(
            (m) => m.AppointmentRsvpComponent
          ),
      },
    ],
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./features/errors/server-error.component').then(
        (m) => m.ServerErrorComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/errors/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
];
